import _extends from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["size", "color"];
var __jsx = React.createElement;
import React from "react";
const ArrowLeftIcon = _ref => {
  let {
      size = "20",
      color = "currentColor"
    } = _ref,
    attributes = _objectWithoutProperties(_ref, _excluded);
  return __jsx("svg", _extends({
    width: size,
    viewBox: "0 0 14 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, attributes), __jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4.5C14 4.22386 13.7761 4 13.5 4L1.70711 4L4.85355 0.853554C5.04882 0.658292 5.04882 0.341708 4.85355 0.146446C4.65829 -0.0488167 4.34171 -0.0488167 4.14645 0.146446L0.146446 4.14645C-0.0488157 4.34171 -0.0488157 4.65829 0.146446 4.85355L4.14645 8.85355C4.34171 9.04882 4.65829 9.04882 4.85355 8.85355C5.04882 8.65829 5.04882 8.34171 4.85355 8.14645L1.70711 5L13.5 5C13.7761 5 14 4.77614 14 4.5Z",
    fill: color
  }));
};
export default ArrowLeftIcon;